import { render } from "./OkDialog.vue?vue&type=template&id=021130e0&scoped=true"
import script from "./OkDialog.vue?vue&type=script&lang=js"
export * from "./OkDialog.vue?vue&type=script&lang=js"

import "./OkDialog.vue?vue&type=style&index=0&id=021130e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021130e0"]])

export default __exports__